<template>
  <v-button
    ghost
    secondary
    small
    with-icon
    :class="
      `${isLiked ? '--has-liked' : ''} ${
        !isLikedInitially ? '--animate' : ''
      } feed-like mr-n1`
    "
    @click="handleClick"
  >
    <v-icon icon="favorite" />
    <span v-if="reactionCount > 0" class="feed-like__number">
      {{ reactionCount }}
    </span>
    {{ pluralize("Like", reactionCount) }}
  </v-button>
</template>

<script>
import { mapGetters } from "vuex"
import { isPresent, pluralize } from "@/lib/utils"

export default {
  components: {},

  props: {
    message: { type: Object, required: true },
    isLiked: { type: Boolean, default: false }
  },

  data() {
    return {
      isLikedInitially: false
    }
  },

  computed: {
    ...mapGetters("auth", ["isAuthenticated"]),

    reactionCount() {
      return isPresent(this.message) ? this.message.reaction_count : 0
    },

    hasReactions() {
      return this.reactionCount > 0
    }
  },

  mounted() {
    this.isLikedInitially = this.isLiked
  },

  methods: {
    pluralize,

    handleClick() {
      if (!this.isAuthenticated) return this.$router.push("#auth")

      if (this.isLiked) {
        this.$emit("unlike")
        this.isLikedInitially = false
      } else {
        this.$emit("like")
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables";

.feed-like {
  .v-icon {
    font-size: 1rem;
    position: relative;
    top: 2px;
    margin-right: 0.25rem;
  }

  &.--has-liked {
    color: $color-ui--red;

    &.--animate {
      .v-icon {
        animation: heart-react 1s ease-in-out;
      }
    }
  }
}
</style>

<style lang="scss">
.v-button.feed-like {
  overflow: visible; // Allows heart animation to play
}
</style>
